import React from 'react'
import Invoice from './Invoice'
import { Route, Routes, Navigate } from 'react-router-dom';
import InvoiceList from './InvoiceList';
import ViewInvoice from './ViewInvoice';
import EditInvoice from './EditInvoice';

export default function InvoiceRoute() {
     return (
          <Routes>
               <Route path="/" element={<InvoiceList />} />  
               <Route path="/new" element={<Invoice />} />            
               <Route path="/view/:id" element={<ViewInvoice />} />
               <Route path="/edit/:id" element={<EditInvoice />} />
          </Routes>
     )
}
